module.exports = __webpack_public_path__ + "img/bg3.877228c5.png";